import { modals } from '@mantine/modals';

import { TSDListItem } from '@e-origin/contracts';

import { SimulateTsdStatusUpdate } from '@features/tsd/TSDList/CustomsSimulator/SimulateTsdStatusUpdate';
import { SimulateTsdAccepted } from './SimulateTsdAccepted';
import { SimulateTsdActivation } from './SimulateTsdActivation';
import { SimulateTsdPNLinkingResult } from './SimulateTsdPNLinkingResult';
import { SimulateTsdWriteOff } from './SimulateTsdWriteOff';

interface OpenSimulatorModalProps {
  tsd: TSDListItem;
  onSubmit: (payload?: Record<string, unknown>) => void | Promise<void>;
}

export const TSDSimulatorModalManager = {
  openAccepted: ({ tsd, onSubmit }: OpenSimulatorModalProps) => {
    modals.open({
      title: 'Simulate IETS028 - Accepted',
      children: <SimulateTsdAccepted tsd={tsd} onHide={modals.closeAll} onSubmit={onSubmit} />,
      size: 'lg',
    });
  },

  openActivation: ({ tsd, onSubmit }: OpenSimulatorModalProps) => {
    modals.open({
      title: 'Simulate IETS029 - TSD Activation',
      children: <SimulateTsdActivation tsd={tsd} onHide={modals.closeAll} onSubmit={onSubmit} />,
      size: 'md',
    });
  },

  openPNLinkingResult: ({ tsd, onSubmit }: OpenSimulatorModalProps) => {
    modals.open({
      title: 'Simulate IETS030 - PN Linking Result',
      children: <SimulateTsdPNLinkingResult tsd={tsd} onHide={modals.closeAll} onSubmit={onSubmit} />,
      size: 'lg',
    });
  },

  openWriteOff: ({ tsd, onSubmit }: OpenSimulatorModalProps) => {
    modals.open({
      title: 'Simulate IETS045 - Write-off',
      children: <SimulateTsdWriteOff tsd={tsd} onHide={modals.closeAll} onSubmit={onSubmit} />,
      size: 'xl',
    });
  },
  openStatusUpdate: ({ tsd, onSubmit }: OpenSimulatorModalProps) =>
    modals.open({
      title: 'Simulate IETS095 - Status Update',
      children: <SimulateTsdStatusUpdate tsd={tsd} onHide={modals.closeAll} onSubmit={onSubmit} />,
      size: 'lg',
    }),
};
